import sidebar from '@/config/sidebars/admin_hubspot'
import createVueApp from '@/common/create_app'

Styxie.Initializers.AdminHubspot = {
  show: async(props) => {
    const { default: Dashboard } = await import('@/vue_widgets/admin/hubspot/dashboard/index.vue')
    createVueApp(Dashboard, { props, sidebar })
  }
}
